import React, { useEffect, useState, useRef } from 'react';
import { useIdleTimer } from 'react-idle-timer'
import { useNavigate } from "react-router-dom";

import {logout} from '../services/authService';

import { useQuery } from './QueryContext';
import UserQuestion from './UserQuestion';
import ChatResponse from './ChatResponse';
import ChatLoading from './ChatLoading';
import ChatWarning from './ChatWarning';
import ChatLegalStatements from './ChatLegalStatements';
import ChatWelcome from './ChatWelcome';


function Responses(props) {            
    
    const [ localResponses, setLocalResponses ] = useState('');   
    const navigate = useNavigate();

    const onIdle = () => {logout()};

    useIdleTimer({
        onIdle: onIdle,
        timeout: 1000 * 60 * 15,
        throttle: 500
    });

    const [ currentQuestion, setCurrentQuestion ] = useState('');
    const lastResponseRef = useRef(null);

    const username = sessionStorage.getItem('username');

    const legalDisclaimer = {
        "naturalLanguageQuery" : "what doth life?",
        "classification" : 'legal',
        "response" : 'blah'
    };

    // const welcomePost = {
    //     "naturalLanguageQuery" : "N/A",
    //     "classification" : 'welcome',
    //     "response" : 'N/A'
    // }
    const [ postsArray, setPostsArray ] = useState([legalDisclaimer]);
    // Helper method to append a single post to our postsArray State
    const addPostToPostsArray = (post) => {
        setPostsArray([...postsArray, post]);
    }

    // Monitor for value changes from Query...
    const { value } = useQuery();

    const postQuery = async ( nlq ) => {
        // console.log(`DEBUG: posting for nlq: ${nlq}`);
        setLocalResponses(`${localResponses}\nQUESTION: ${nlq}\n`);

        // console.log(`Classification: ${props.classification}`)
        // console.log(`Language: ${props.language}`)

        const body = JSON.stringify({
            "question": nlq,
            "fullyParameterizedParameters":[],
            "partiallyParameterizedParameters":[],
            "cache":true,
            "context": {
                "productName": props.product,
                "productVersion": props.vers,
                "language":props.language,
                "classification": props.classification
            }
        });
        const header = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'cloudtoken': sessionStorage.getItem('idToken'),
            'cloudtoken2': sessionStorage.getItem('accessToken'),
            
        };
        await fetch(window.apiURL , {mode:'cors', method:'POST', headers:header, body: body })
            .then((response) => {
                if (response["status"] === 401)
                {
                    if (window.confirm("Your session has expired\n would you like to log out and back in"))
                    {
                        sessionStorage.clear();
                        sessionStorage.setItem("username","")
                        navigate(`/login`)
                    }
                }
                return response.json();
                
            })            
            .then((data) => {
                if (data['statusCode'] === 200 )
                {    
                    // console.log(data);
                    const singlePost = {
                        "naturalLanguageQuery" : nlq,
                        "classification" : data['body']['classification'],
                        "response" : data['body'],
                        "product": props.product,
                        "version": props.vers
                        };

                    // console.log(`addPostToPostsArray: ${singlePost}`)
                    addPostToPostsArray(singlePost);
                    //If it's a legal error, we want to spawn the legal statements again
                    //So that if, somehow, they reach here thru the UI, they aren't confused and discouraged
                    if(data['body']['classification']==='msg' && data['body']['subclassification']==='legal'){
                        addPostToPostsArray(legalDisclaimer);
                    }
                    setCurrentQuestion("");
                }
                else if ([401, 403].includes(data["statusCode"] ) )
                    {
                        sessionStorage.clear();
                        sessionStorage.setItem("username","")
                        navigate(`/login`)                    
                    }   
                    
                else if(data['statusCode'] === 504 )
                    { 
                    setTimeout(() => 
                            {
                            console.log("waiting")
                            fetch(window.apiURL, {mode:'cors', method: 'POST', headers: header, body: body}).then(
                                (responce) => responce.json()).then((data) =>{
                                    const singlePost = {
                                        "naturalLanguageQuery" : nlq,
                                        "classification" : data['body']['classification'],
                                        "response" : data['body'],
                                        "product": props.product,
                                        "version": props.vers
                                        };
                                        setCurrentQuestion("");
                                        console.log(`addPostToPostsArray: ${singlePost}`)
                                        addPostToPostsArray(singlePost)
                                });
                            }
                        , 40000);                                         
                    }
                else {
                    const badAnser ={
                        "naturalLanguageQuery" : nlq,
                        "classification" :"msg",
                        "response": {"answer":data['message']}};
                        setCurrentQuestion("");
                        addPostToPostsArray(badAnser);
                }
    

                // Create a post based on the data, and add it to our state...

            })
            .catch((err) => {                

                console.log(err);
                const badAnser ={
                    "naturalLanguageQuery" : nlq,
                    "classification" :"msg",
                    "response": {"answer":  err["message"]}};
                    setCurrentQuestion("");
                    addPostToPostsArray(badAnser);

                                
            });

    }

    useEffect(() => {
        // setLocalResponses(`${localResponses}\n${value}`); // Force a repaint...
        setCurrentQuestion(value);
        
        if(value.length > 0) {            
            postQuery(value);     
            }
        // i Dont really understand how to turn of this warning so i am disabling it
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [value]);

    // Monitor for changing of currentQuestion to force render...
    useEffect(() => {

    }, [currentQuestion])

    // Monitor postsArray for state changes, and invokve processPostsArray whenever change detected...
    useEffect(() => {
        const processPostsArray = async (postsArray) => {
            // Walk through the postsArray and process each post into a string for presentation in our textArea control...
            var stringPresentation = "";
            postsArray.forEach(post => {
                var stringData = "";

                if(post['classification'] === 'nlh')
                    stringData = processNLHResponseIntoString(post['response']);
                else if(post['classification'] === 'legal')
                    stringData = 'This chat tool utilizes generative artificial intelligence and large language models, which may produce errors or inaccuracies. Information provided by tool is intended for general informational purposes only and should not be relied upon as the sole basis for making any decision, including but not limited to legal or regulatory decisions. The chatbot is still learning and accuracy may vary. The chat tool does not require personal information, please do not include any in your queries. All information provided by the chat tool includes a reference to the source documentation and specifications; always consult the referenced documentation and specifications to verify the information provided by the chat tool. You are responsible for reviewing applicable safety requirements in the source documentation.';
                stringPresentation = `${stringPresentation}\nQUESTION[${post['classification']}]: ${post['naturalLanguageQuery']}\nANSWER: ${stringData}\n`;
            });
            setLocalResponses(stringPresentation);
        } 
        processPostsArray(postsArray);
    }, [postsArray]);

    const processNLHResponseIntoString = (data) => {
        var response = "";
        /* 
        {
            "question" : "...",
            "answer" : "...",
            "sources" : "...",
            "source_documents" : [
                {
                    "page_content" : "...",
                    "metadata" : {
                        "source" : "document name",
                        "page" : pageNumber
                    }
                    "type" : "Document"
                }
            ]
        }
        */

        // Add the answer
        response = data['answer'];

        // Append the source documents metadata (source, page)
        var source_documents = response['sources'];
        source_documents.forEach(source_document => {
            response = `${response}\n\t${source_document['filename']}, page ${source_document['pageNumberRange']}`
        });

        return response;
    }

    // When a new answer arrives, scroll to the top of it so the user reads from the beginning.
    useEffect(() => {
        lastResponseRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, [postsArray]);

    // When a question is submitted, scroll down to reveal the loading indicator.
    useEffect(() => {
        if (currentQuestion) {
            const container = document.getElementById('ResponseTextAreaID');
            if (container) container.scrollTop = container.scrollHeight;
        }
    }, [currentQuestion]);

    const processIntoHTML = (post, index) => {
        var naturalLanguageQuery = post['naturalLanguageQuery'];
        var classification = post['classification'];
        var response = post['response'];
        // console.log(postsArray)
        switch(classification) {
            case "nlh" : return processNLHIntoHTML(index, naturalLanguageQuery, classification, response, post);
            case "legal" : return processLegalIntoHTML(index);   
            case "welcome" : return processWelcomeIntoHTML(index);  
            default: return processQueryIntoHTML(index, naturalLanguageQuery, classification, response);
        }
    }

    const processQueryIntoHTML = (index, naturalLanguageQuery, classification, response) => {
        return (
            <div className='BeforeResponse' key={index}> 
                <div className='Question' style={{display: 'flex', justifyContent: 'flex-end'}}>
                    <UserQuestion 
                        username={username}
                        naturalLanguageQuery={naturalLanguageQuery}
                    />
                </div>
                   <ChatWarning warningMessage={response['answer']} product={props.product}/> 
               <br></br>
            </div>
        )
    }

    const processNLHIntoHTML = (index, naturalLanguageQuery, classification, response, post) => {
        /* 
        {
            "question" : "...",
            "answer" : "...",
            "sources" : "...",
            "source_documents" : [
                {
                    "page_content" : "...",
                    "metadata" : {
                        "source" : "document name",
                        "page" : pageNumber
                    }
                    "type" : "Document"
                }
            ]
        }
        */        
        
        // Split the answer by newlines...
        var answerBodyArray = response['answer']['body'].split("\n");
        var answerSource = response['answer']['sources'];
        var answerTitle = response['answer']['title'];
        var answerIntro = response['answer']['introduction'];
        var answerConclusion = response['answer']['conclusion'];

        if (answerSource.length === 0 || answerSource[0]["documentTitle"] === ""){
            return (
                <div className='BeforeResponse' key={index}> 
                    <div className='Question' style={{display: 'flex', justifyContent: 'flex-end'}}>
                        <UserQuestion 
                            username={username}
                            naturalLanguageQuery={naturalLanguageQuery}
                        />
                    </div>
                   <ChatWarning warningMessage={"I don't have enough information to answer that question"}/>           
                   <br></br>
                </div>
            )
        }

        return (            
            <div className='NLHResponse' key={index} id={'nlhreponce' + index}> 
                <br></br>
                <div className='Question' style={{display: 'flex', justifyContent: 'flex-end'}}>
                    <UserQuestion 
                        username={username}
                        naturalLanguageQuery={naturalLanguageQuery}
                    />
                </div>
                    
                <div className='Response' style={{display: 'flex', justifyContent: 'flex-start'}}>
                    <ChatResponse
                        answerTitle={answerTitle}
                        answerIntro={answerIntro}
                        answerBodyArray={answerBodyArray}
                        answerConclusion={answerConclusion}
                        answerSource={answerSource}
                        language={props.language}
                        product={post.product || props.product}
                        version={post.version || props.vers}
                        // add_like={add_like}
                        // add_dislike={add_dislike}
                        response={response}
                        id = {response['answer']['id']}
                    />
                </div>
                
                <p name="qid" style={{ marginTop: '20px', fontSize: '0.9em', color: '#555' }}>
                    
                </p>
            </div>
        )
    }

    // <ChatLegalDisclaimer
    //                 language={props.language}
    //                 confirm_legal={confirm_legal}
    //                 deny_legal={deny_legal}
    //                 msgEnabled={props.msgEnabled}
    //                 />
    const processLegalIntoHTML = (index) => {

        return (            
            <div className='LegalDisclaimer' key={index}> 
                <br></br>

                <ChatLegalStatements
                    index={index}
                    language={props.language}
                    msgEnabled={props.msgEnabled}
                    setMsgEnabled={props.setMsgEnabled}
                    postsArray={postsArray}
                    setPostsArray={setPostsArray}
                    />
            </div>
        )
    }

    const processWelcomeIntoHTML = (index) => {
        return(
            <div className='WelcomeMessage' key={index}> 
                <br></br>
                <ChatWelcome product={props.product}/>
            </div>
        )
    }

    const processCurrentQuestionIntoHTML = () => {
        var index = -1;
        if(currentQuestion === "" || !props.msgEnabled) {
            return        
        } else {
            return (
                <div className='BeforeResponse' key={index}>
                    <div className='Question' style={{display: 'flex', justifyContent: 'flex-end'}}>
                        <UserQuestion 
                            username={username}
                            naturalLanguageQuery={currentQuestion}
                        />
                    </div>
                    <ChatLoading product={props.product}/>
                    <br></br>
                </div>
            )
        }
    }    

    return (  
        // <div className='row'>                 
        <div className='ResponseTextArea' id='ResponseTextAreaID'>     
            {postsArray.map((post, index) => (
                <React.Fragment key={index}>
                    {index === postsArray.length - 1 && <div ref={lastResponseRef} />}
                    {processIntoHTML(post, index)}
                </React.Fragment>
            ))}                        
            {processCurrentQuestionIntoHTML()}
            
        </div>   
        // </div>   
    )
}  

export default Responses;